<template>
  <div class="tva-parallax" ref="container">
    <div
      class="tva-image"
      :style="{
        transform: `translateY(-${offset}px)`,
        backgroundImage: `url(${baseUrl + content})`,
        height: `${imageHeight}%`,
        backgroundPosition: `${imagePosition}`,
        transition: `transform ${ease} ease-out`
      }"
      ref="image"
    ></div>
  </div>
</template>

<script>
import { scaleLinear } from "d3-scale";

export default {
  data() {
    return {
      offset: 0,
      scrollY: 0,
      baseUrl: process.env.BASE_URL,

      imagePosition: "50% 50%",
      speed: 1.5,
      ease: "0.5s"
    };
  },
  props: {
    config: { type: Object, default: null },
    content: { type: String }
  },
  created() {
    if (this.config) {
      _.forEach(this.config, (value, key) => {
        this[key] = value;
      });
    }
    this.$nextTick(() => {
      window.addEventListener("scroll", () => {
        this.scroll();
      });
    });
  },
  computed: {
    imageHeight() {
      return 100 * this.speed;
    }
  },
  watch: {
    config(config) {
      this.setProps(config);
    },
    scrollY(scrollY) {
      let position = this.$refs.container.getBoundingClientRect().top;
      let containerHeight = this.$refs.container.getBoundingClientRect().height;
      let imageHeight = this.$refs.image.getBoundingClientRect().height;

      if (position < scrollY && position + containerHeight > 0) {
        // Container is in viewport

        let scale = scaleLinear()
          .domain([window.innerHeight + containerHeight, 0])
          .range([0, imageHeight - containerHeight]);

        this.offset = scale(position + containerHeight);
      }
    }
  },
  methods: {
    setProps(config) {
      if (config) {
        _.forEach(config, (value, key) => {
          this[key] = value;
        });
      }
    },
    scroll() {
      if (this.scrollY !== window.pageYOffset) {
        this.scrollY = window.pageYOffset;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tva-parallax {
  height: 600px;
  overflow: hidden;
  position: relative;
  .tva-image {
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
  }
}
</style>
